export default {
    "de": {
        "calendar": {
            "today": "Heute",
            "new_appointment_at": "Neuer Termin um"
        }
    }
}
